import React from 'react';
import { Component } from "puzzle";
import SupplementaryFilesUploadGrid from "./SupplementaryFilesUploadGrid";
import { DROPUPLOAD_PROPS } from "../../../Submission/BatchUpload/Types";
import { COLLATERAL_FILES, LANGUAGE } from "./Types";

type SUPP_FILES_UPLOAD_PROPS = {
  taskId: number,
  languages: LANGUAGE[],
  filesToUpload: COLLATERAL_FILES[]
} & DROPUPLOAD_PROPS;

class SupplementaryFilesUpload extends Component<SUPP_FILES_UPLOAD_PROPS, {}> {

  render() {
    return (
      <div>
        <SupplementaryFilesUploadGrid
          {...this.props}
          moduleId={'supplementaryFiles'}
          uploadActionName={'uploadFiles'}
        />
      </div>
    );
  }
}

export default SupplementaryFilesUpload;
